<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright"><a id="page_iv"></a>© 2012 The Johns Hopkins University Press<br/>All rights reserved. Published 2012<br/>Printed in the United States of America on acid-free paper<br/>9 8 7 6 5 4 3 2 1</p>
<p class="copyright">The Johns Hopkins University Press<br/>2715 North Charles Street<br/>Baltimore, Maryland 21218-4363<br/><a class="nounder" href="http://www.press.jhu.edu" target="_blank">www.press.jhu.edu</a></p>
<p class="copyright">Library of Congress Cataloging-in-Publication Data</p>
<p class="copyright">Prescribed : writing, filling, using, and abusing the prescription in modern<br/>America / edited by Jeremy A. Greene and Elizabeth Siegel Watkins.<br/>       p. ; cm.<br/>  Includes bibliographical references and index.<br/>  ISBN-13: 978-1-4214-0506-3 (hdbk. : alk. paper)<br/>  ISBN-13: 978-1-4214-0507-0 (pbk. : alk. paper)<br/>  ISBN-10: 1-4214-0506-7 (hdbk. : alk. paper)<br/>  ISBN-10: 1-4214-0507-5 (pbk. : alk. paper)<br/>  I. Greene, Jeremy A., 1974- II. Watkins, Elizabeth Siegel.<br/>  [DNLM: 1. Prescriptions—history—United States. 2. Government<br/>Regulation—history—United States. 3. History, 20th Century—United<br/>States. 4. Professional Autonomy—United States. 5. Substance-Related<br/>Disorders—history—United States. QV 11 AA1]<br/>  LC classification not assigned<br/>  615.1’4—dc23                                         2011029814</p>
<p class="copyright">A catalog record for this book is available from the British Library.</p>
<p class="copyright"><em>Special discounts are available for bulk purchases of this book. For<br/>more information, please contact Special Sales at 410-516-6936 or</em><br/><a class="nounder" href="mailto:specialsales@press.jhu.edu"><em>specialsales@press.jhu.edu</em></a>.</p>
<p class="copyright">The Johns Hopkins University Press uses environmentally friendly<br/>book materials, including recycled text paper that is composed of at least<br/>30 percent post-consumer waste, whenever possible.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copy.vue?aa8c2ef2